
/* ============================== src/api/queries/files.js ============================== */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export const FILES_KEY = ["files"];
export const FOLDERS_KEY = ["folders"];

export function useUploadFileMutation(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      file,
      folderId = null,
      ownerType,
      ownerId,
      taskId,
      projectId,
      onUploadProgress,
    }) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("ownerType", ownerType);
      formData.append("ownerId", ownerId);
      if (folderId) formData.append("folderId", folderId);
      if (taskId) formData.append("taskId", taskId);
      if (projectId) formData.append("projectId", projectId);

      const config = { headers: { "Content-Type": "multipart/form-data" } };
      if (typeof onUploadProgress === "function") {
        config.onUploadProgress = onUploadProgress;
      }

      return api.post("/files", formData, config);
    },
    onSuccess: () => {
      // Если передан { invalidate: false }, пропускаем авто-обновление кэша
      if (options.invalidate !== false) {
        qc.invalidateQueries({ queryKey: ["tasks"] });
        qc.invalidateQueries({ queryKey: ["projects"] });
        qc.invalidateQueries({ queryKey: ["comments"] });
      }
    },
  });
}

export function useDeleteFileMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fileId) => api.delete(`/files/${fileId}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["tasks"] });
      qc.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}

export function useMoveFileMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ fileId, folderId }) =>
      api.patch(`/files/${fileId}/move`, { folderId }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["tasks"] });
      qc.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}

export function useRenameFileMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ fileId, name }) =>
      api.patch(`/files/${fileId}/rename`, { name }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["tasks"] });
      qc.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}

export function useCreateFolderMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ name, parentId = null, ownerType, ownerId }) =>
      api.post("/files/folders", { name, parentId, ownerType, ownerId }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["tasks"] });
      qc.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}

export function useMoveFolderMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ folderId, parentId }) =>
      api.patch(`/files/folders/${folderId}/move`, { parentId }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["tasks"] });
      qc.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}

export function useDeleteFolderMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (folderId) => api.delete(`/files/folders/${folderId}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["tasks"] });
      qc.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}
